import { render, staticRenderFns } from "./EventsCalendarPage.vue?vue&type=template&id=66e0c8cc"
import script from "./EventsCalendarPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsCalendarPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports